var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteractionLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 120,
    viewBox: "0 0 119 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1467_95276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3691 68.8624L20.3967 94.0198L47.8819 78.0299L49.8935 89.5904C49.9688 89.5012 50.0372 89.4189 50.1262 89.3092C50.4341 89.4464 50.7488 89.5835 51.0635 89.7206C50.9198 89.8921 50.7625 90.2143 50.6462 90.1937C50.4135 90.1595 50.1809 90.0635 49.9551 89.9675L55.1757 120C55.1757 120 61.8195 98.7921 66.5749 83.3164L68.7439 85.2843C68.7439 85.1815 68.7439 85.0855 68.7575 84.9689C69.0381 84.9003 69.3323 84.8249 69.6197 84.7495C69.6197 84.9415 69.6744 85.25 69.5854 85.298C69.4075 85.4009 69.1954 85.4557 68.9902 85.5106L88.6342 103.359C88.6342 103.359 79.9446 80.0526 74.984 67.0591L119 62.5542L78.3024 52.1593L101.826 29.5869L71.3849 42.9302L67.3412 28.2704L62.3669 10.2509L62.0864 9.24294L59.5274 -0.0136719L57.3858 10.4497C57.4337 10.5183 57.4747 10.5869 57.5158 10.6623C57.4679 10.9023 57.4131 11.1491 57.3652 11.396C57.3379 11.4302 57.3036 11.4577 57.2763 11.4851C57.2489 11.444 57.2215 11.4028 57.1942 11.3685L55.6957 18.6915C55.7436 18.6778 55.7984 18.6641 55.8531 18.6504C55.6684 19.5349 55.4836 20.4126 55.2989 21.2834C55.2441 21.3177 55.1962 21.352 55.1483 21.3862L54.4846 24.6364L52.0078 36.7591L47.964 33.749L34.909 24.0261L34.1838 23.4844L27.4784 18.4927L34.1838 32.0691L34.8475 33.413L44.3308 52.605L0 63.3359L40.3691 68.8693V68.8624ZM59.3016 18.5201C59.3016 18.5201 59.3495 18.5201 59.3768 18.5133C59.3495 18.5338 59.3289 18.5476 59.3016 18.5613V18.5201Z",
    fill: "#DEDEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1467_95276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractionLogoDark);
export default __webpack_public_path__ + "static/media/interaction_logo_dark.f524bce1c38f4e80c10aacccdfd7f9f2.svg";
export { ForwardRef as ReactComponent };